import axios from 'axios';
import { Server, ServersResponse, ServerStatus } from '../models/Server';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};

export const serverService = {
  async getAllServers(): Promise<ServersResponse> {
    const response = await axios.get(`${API_URL}/api/server`, {
      headers: getHeaders(),
    });
    return response.data;
  },

  async getPublicServerCount(): Promise<number> {
    const response = await axios.get(`${API_URL}/api/server/publiccount`);
    return response.data.count;
  },

  async getAvailableServers(): Promise<Server[]> {
    const response = await axios.get(`${API_URL}/api/server/available`);
    return response.data.servers;
  },

  async getServerById(serverId: number): Promise<Server> {
    const response = await axios.get(`${API_URL}/api/server/${serverId}`, {
      headers: getHeaders(),
    });
    return response.data;
  },

  async getServerStatus(serverId: number): Promise<ServerStatus> {
    const response = await axios.get(`${API_URL}/api/server/${serverId}/status`, {
      headers: getHeaders(),
    });
    return response.data;
  },

  async createServer(server: Omit<Server, 'id'>): Promise<Server> {
    const response = await axios.post(`${API_URL}/api/server`, server, {
      headers: getHeaders(),
    });
    return response.data;
  },

  async updateServer(serverId: number, server: Server): Promise<Server> {
    const response = await axios.put(`${API_URL}/api/server/${serverId}`, server, {
      headers: getHeaders(),
    });
    return response.data;
  },

  async deleteServer(serverId: number): Promise<void> {
    await axios.delete(`${API_URL}/api/server/${serverId}`, {
      headers: getHeaders(),
    });
  },
};